import React, { FC } from 'react';

export interface PageBannerContainerProps {
  color?: string;
  backgroundImage?: string;
  style?: React.CSSProperties;
  backgroundSize?: string;
}

export const PageBannerContainer: FC<PageBannerContainerProps> = ({
  color,
  backgroundImage,
  children,
  style = {},
  backgroundSize = 'contain',
}) => {
  const background = [color, backgroundImage && `url("${backgroundImage}") no-repeat center bottom`]
    .filter(Boolean)
    .join(' ');
  return (
    <div
      style={{
        padding: '0 32px 56px',
        background,
        height: 'clamp(30vh, 300px, 20vh)',
        backgroundSize,
        borderRadius: '8px',
        marginBottom: '16px',
        ...style,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {children}
      </div>
    </div>
  );
};
